import RecommendedPassword from '@/Components/RecommendedPassword';

export default {
  components: { RecommendedPassword },
  data() {
    return {
      recommended: {
        lowerCaseLetters: false,
        upperCaseLetters: false,
        numbers: false,
        symbols: false,
        lengthText: false,
        passwordError: false
      }
    };
  },
  computed: {
    recommendedType() {
      if (
        this.recommendedPasswordCount > 2 &&
        this.recommendedPasswordCount < 5
      ) {
        return 'warning';
      } else if (this.recommendedPasswordCount >= 5) {
        return 'success';
      } else {
        return 'error';
      }
    },
    recommendedText() {
      if (this.recommendedType === 'warning') {
        return 'סיסמה סבירה';
      } else if (this.recommendedType === 'success') {
        return 'סיסמה חזקה';
      } else {
        return 'סיסמה חלשה';
      }
    },
    recommendedPasswordCount() {
      let count = 0;

      for (const k in this.recommended) {
        if (this.recommended[k]) {
          count++;
        }
      }
      return count;
    }
  },
  methods: {
    recommendedPassword(pass) {
      this.recommended.lowerCaseLetters =
        pass.match(/[a-z]/g) && !pass.match(/[а-з]/g) ? true : false;
      this.recommended.upperCaseLetters =
        pass.match(/[A-Z]/g) && !pass.match(/[А-З]/g) ? true : false;
      this.recommended.numbers = pass.match(/[0-9]/g) ? true : false;
      this.recommended.symbols = pass.match(/[.*+?^${}!@#%&_:<>()|/\-[\]\\]/g)
        ? true
        : false;
      this.recommended.lengthText = pass.length >= 9 ? true : false;
    }
  }
};
